import { createZustandStore } from '../../../zustand';

import { IAssessmentDetailsState } from './types';

export const useAssessmentsDetailsStore =
  createZustandStore<IAssessmentDetailsState>((set) => ({
    imagePosition: '',
    updateImagePosition: (position) => set(() => ({ imagePosition: position })),
    selectedImageRetakeReasons: {},
    updateSelectedImageRetakeReasons: (reasons) =>
      set(() => ({ selectedImageRetakeReasons: reasons })),
    resetSelectedImageRetakeReasons: () =>
      set(() => ({ selectedImageRetakeReasons: {} })),
    updateOtherReasonInput: (position, otherReasonInput) =>
      set((state) => ({
        selectedImageRetakeReasons: {
          ...state.selectedImageRetakeReasons,
          [position]: {
            ...state.selectedImageRetakeReasons[position], // Ensure existing data isn't lost
            position, // Explicitly set position if new
            retakeReasonIds:
              state.selectedImageRetakeReasons[position]?.retakeReasonIds || [],
            comment: otherReasonInput,
          },
        },
      })),
  }));
